import React from "react";
import { RbacContext } from "../../contexts/rbac/index.js";
export const RbacProvider = ({
  canActivate,
  children
}) => {
  return /*#__PURE__*/React.createElement(RbacContext.Provider, {
    value: canActivate
  }, children);
};
RbacProvider.displayName = "RbacProvider";
RbacProvider.defaultProps = {
  // This let's any route pass by setting canActivate return value to true
  canActivate: (p, r, a, f) => true
};